import React,{ Fragment, useEffect, useState } from "react";
import { clean_estado } from '../redux/Appslice';
import { useDispatch } from 'react-redux';
import Gracias from '../components/Gracias';

const Tarjetas = ({card, estado, ingresos}) => {

    console.log(ingresos)

    const dispatch = useDispatch();

    const [activeIndex, setActiveIndex] = useState("");
    const [pedila, setPedila] = useState(0);

    useEffect(() => {
        if (card === "tarjetaVisa"){
            setActiveIndex(4);
           
        }else if(card === "tarjetaMaster") {
            setActiveIndex(6);
        }
      },[card]);


    const handleDivClick = (index) => {
        setActiveIndex(index);
      };
    
    const handleclickVolver = () => {
        dispatch(clean_estado());
        var cards = document.getElementById("cards");
        cards.classList.remove("activo");
        cards.classList.add("inactivo");
    }

    var cards = document.getElementById("cards");
    if(cards){
        if(estado === "activo"){
            cards.classList.add("activo");
            cards.classList.remove("inactivo");
        }
    }

    const handleclickPedila = () => {
        setPedila(1);
    }

    return(
        <Fragment>
        <div id="cards">
            <div className="content">
            <div id="logo-tarjetas">
                <img src="img/logo-scotiapuntos.png" alt="logo"></img>
            </div>
            <h2>Elegí la tarjeta que tenga<br></br> los mejores beneficios para vos</h2>
            <div id="card-grande">
                <img src={`img/mano-${activeIndex}.png`} alt="mano"></img>
            </div>
            <div id="thumbs">
               
                {
                    (() => {
                        if(card === "tarjetaVisa"){
                           if(ingresos >= 13000 && ingresos < 60000) {
                                return(<div className={`thumb ${activeIndex === 4 ? 'active' : ''}`} onClick={() => handleDivClick(4)}><img src="img/visa-scotiapuntos.png" alt="scotiapuntos"></img></div>)
                            }else if(ingresos >= 60000 && ingresos < 75000) {
                                return(
                                    <>
                                        <div className={`thumb ${activeIndex === 4 ? 'active' : ''}`} onClick={() => handleDivClick(4)}><img src="img/visa-scotiapuntos.png" alt="scotiapuntos"></img></div>
                                        <div className={`thumb ${activeIndex === 1 ? 'active' : ''}`} onClick={() => handleDivClick(1)}><img src="img/visa-oro.png" alt="oro"></img></div>            
                                    </>
                                )   
                            } else if(ingresos >= 75000 && ingresos < 100000) { 
                                return( 
                                    <>
                                        <div className={`thumb ${activeIndex === 4 ? 'active' : ''}`} onClick={() => handleDivClick(4)}><img src="img/visa-scotiapuntos.png" alt="scotiapuntos"></img></div>
                                        <div className={`thumb ${activeIndex === 1 ? 'active' : ''}`} onClick={() => handleDivClick(1)}><img src="img/visa-oro.png" alt="oro"></img></div> 
                                        <div className={`thumb ${activeIndex === 3 ? 'active' : ''}`} onClick={() => handleDivClick(3)}><img src="img/visa-platinum.png" alt="platinum"></img></div> 
                                    </>
                                    )
                            } else if(ingresos >= 100000){
                                return(
                                    <>
                                        <div className={`thumb ${activeIndex === 4 ? 'active' : ''}`} onClick={() => handleDivClick(4)}><img src="img/visa-scotiapuntos.png" alt="scotiapuntos"></img></div>
                                        <div className={`thumb ${activeIndex === 1 ? 'active' : ''}`} onClick={() => handleDivClick(1)}><img src="img/visa-oro.png" alt="oro"></img></div> 
                                        <div className={`thumb ${activeIndex === 3 ? 'active' : ''}`} onClick={() => handleDivClick(3)}><img src="img/visa-platinum.png" alt="platinum"></img></div>
                                        <div className={`thumb ${activeIndex === 2 ? 'active' : ''}`} onClick={() => handleDivClick(2)}><img src="img/visa-infinite.png" alt="infinite"></img></div>
                                    </>
                                    )
                           }
            
                        } else if(card === "tarjetaMaster"){
                            if(ingresos >= 13000 && ingresos < 60000) {
                                    return(
                                    <div className={`thumb ${activeIndex === 6 ? 'active' : ''}`} onClick={() => handleDivClick(6)}><img src="img/master-2.png" alt="master"></img></div>
                                    )
                                }else if(ingresos >= 60000){
                                    return(
                                        <>
                                            <div className={`thumb ${activeIndex === 6 ? 'active' : ''}`} onClick={() => handleDivClick(6)}><img src="img/master-2.png" alt="master"></img></div>
                                            <div className={`thumb ${activeIndex === 5 ? 'active' : ''}`} onClick={() => handleDivClick(5)}><img src="img/master-1.png" alt="master"></img></div>   
                                        </>
                                    )
                                }
                        }
                    })()
                }
            <div className="clear"></div>
            </div>
            <div id="beneficios">
                { 
                        activeIndex === 1 ?
                            <>
                            <div className="beneficio"><img src="img/beneficios-1.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-3.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-4.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-5.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-6.png" alt="beneficio"></img></div>
                            </>
                        :
                            null
                }
                {
                     activeIndex === 2 ?
                     <>
                     <div className="beneficio"><img src="img/beneficios-1.png" alt="beneficio"></img></div>
                     <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                     <div className="beneficio"><img src="img/beneficios-3.png" alt="beneficio"></img></div>
                     </>
                 :
                     null
                }
                 {
                     activeIndex === 3 ?
                     <>
                        <div className="beneficio"><img src="img/beneficios-1.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-3.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-4.png" alt="beneficio"></img></div>
                     </>
                 :
                     null
                }
                {
                     activeIndex === 4 ?
                     <>
                        <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-3.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-4.png" alt="beneficio"></img></div>
                     </>
                 :
                     null
                }
                 { 
                        activeIndex === 5 ?
                            <>
                            <div className="beneficio"><img src="img/beneficios-1.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-5.png" alt="beneficio"></img></div>
                            </>
                        :
                            null
                }
                  { 
                        activeIndex === 6 ?
                            <>
                            <div className="beneficio"><img src="img/beneficios-1.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-3.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-5.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-6.png" alt="beneficio"></img></div>
                            </>
                        :
                            null
                }
                <div className="clear"></div>
            </div>
            <div id="botones">
                <div id="volver" onClick={handleclickVolver}>VOLVER</div><div id="pedila" onClick={handleclickPedila}>PEDILA YA</div>
            </div>
            </div>
            {
                  pedila === 1 ?
                  <Gracias />    
                  :
                  null
            }  
            </div>
            </Fragment>
    );
}

export default Tarjetas;